import React, { useState } from "react";
import { faLightbulb } from "@fortawesome/free-regular-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col, Modal, Button, Alert } from "react-bootstrap";
import {validateEmail} from "../../../../_helpers/validators";
import './TeamMembers.scss';

const TeamMembers  = () => {
    const [modalShow, setModal] = useState(false);
    const [emailError, setEmailError] = useState("");


   const invitationModalHandler = () => {
        setModal(!modalShow);
    };

     const handleOnChange = (e) => {
        var email = e.target.value;
      
        if (validateEmail(email)) {
          setEmailError("")
        } else {
          setEmailError('Enter valid Email!')
        }
      };

        return (
            <Container>
                <Row className="team-members-wrapper mt-5">
                    <Col md={8}>
                        <div className="card blur">
                            <div className="heading-wrapper py-3 px-4 bg-grey-2"> 
                                <h3 className="font-weight-medium">Team Members</h3>
                            </div>
                            <div className="bg-grey-5 p-4">
                                <div className="member-info-wrapper d-flex justify-content-between align-items-center p-2 flex-wrap">
                                    <div className="info d-flex align-items-center p-1">
                                        <img src="/assets/images/user.svg" alt="member-img" className="mr-3" />
                                        <p className="fs-smallest font-weight-medium mb-0">Dwayne Johnson</p>
                                    </div>
                                    <p className="email fs-smallest text-grey-4 mb-0 font-weight-medium">dwaynejohnson1998@gmail.com</p>
                                    <p className="fs-smallest text-grey-4 mb-0">You’re a super admin for this job</p>
                                    <FontAwesomeIcon icon={faTrash} className="text-grey-4 cursor-pointer" />
                                </div>

                                <p className="fs-smallest pt-4 mb-1 font-weight-medium px-3">OTHER MEMBERS</p>
                                <p className="fs-smallest text-grey-4 font-weight-medium px-3">You can add other account members to your team or invite people to join Jigsaw to collaborate on this job.</p>
                                <button className="btn btn-outline-light mt-3 px-2" onClick={invitationModalHandler}>
                                    Invite a new member
                                </button>
                            </div>
                        </div>

                        <div className="msg-wrapper bg-primary py-2 px-3 font-weight-medium text-white">
                            Coming Soon
                        </div>
                    </Col>
                </Row >

                {/* delete announcement popup */}

                <Modal
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={modalShow}
                    onHide={invitationModalHandler}
                    className="common-modal"
                >
                    <Modal.Header className="px-4 bg-grey">
                        <Modal.Title id="contained-modal-title-vcenter">
                            <h3>Invite a new member</h3>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="px-4">
                        <h4 className="font-weight-medium mb-2"><span className="text-danger" >* </span>Email</h4>
                        <div className="form-group">
                            <input type="email" placeholder="Enter team member Email"
                                className="form-control bg-transparent px-3 py-4"
                                onChange={(e) => handleOnChange(e)} 
                                />
                            <p className="text-danger fs-smallest font-weight-medium">{emailError}</p>
                        </div>
                        <Alert variant="primary" className="mt-3 d-flex mb-0">
                            <FontAwesomeIcon icon={faLightbulb} className="mr-3 text-primary mt-2" />
                            Invited members will automatically become collaborators for this job, once
                            they signup.
                        </Alert>

                    </Modal.Body>
                    <Modal.Footer className="justify-content-end border-top-0 fs-14 font-weight-semi">
                        <Button
                            onClick={invitationModalHandler}
                            variant=""
                            className="rounded-lg btn btn-outline-light"
                        >
                            Cancel
                        </Button>
                        <Button
                            variant=""
                            className="rounded-lg  btn btn-primary"
                        >
                            Send Invitation
                        </Button>
                    </Modal.Footer>
                </Modal>
         </Container>
        );
}
export default TeamMembers;
